import api from '../services/api';

interface UploadedAttachment {
  tempId: string;
  fileName: string;
  fileSize: number;
  contentType: string;
}

/** Upload an image for inline embedding in rich-text profile bios (temp attachment path). */
export async function uploadInlineImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('files', file);
  const response = await api.post<UploadedAttachment[]>('/api/Attachment/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  if (!Array.isArray(response) || response.length === 0) {
    throw new Error('No file returned from server');
  }
  const uploaded = response[0];
  return `/api/Attachment/temp/${uploaded.tempId}`;
}
